@if(errors){
<div *ngFor="let e of errors | keyvalue">
  @switch (e.key) {
    @case ('required') {
    <div>
      <small class="form-danger">Campo obbligatorio per la pubblicazione del viaggio</small>
    </div>
    }
    @case ('maxlength') {
      <div>
        <small class="form-danger">Limite di caratteri raggiunto</small>
      </div>
      }
      @case ('minlength') {
        <div>
          <small class="form-danger">Prova a dirci di più</small>
        </div>
        }
    @default {
    <small class="form-danger">{{ e.value }}</small>
    }
  }
</div>
}